// 作者:xu.ruliang
// 时间:2017/3/31
// 描述:new图片剪裁应用
'use strict';
angular.module('newCropperHeaderlogoModule', []).controller('newCropperHeaderlogoCtrl', ['$scope', '$q', '$modalInstance', '$timeout', 'params', 'editPictureService', 'modalDialog', 'trsHttpService', function($scope, $q, $modalInstance, $timeout, params, editPictureService, modalDialog, trsHttpService) {
    var $img, img, event, options, containerWidth, containerHeight, imgHeight, imgWidth, imgRatio, flag = true;
    initStatus();
    initData();

    /**
     * [initStatus description]初始化状态
     */
    function initStatus() {
        $scope.status = {
            rotate: 0,
            imgSrc: params.imgSrc
        };
    }

    function initCropper() {
        var deffer = $q.defer();
        $timeout(function() {
            $img = $('#img');
            var imgType = editPictureService.getImageType($scope.status.imgSrc);
            img = new Image();
            img.src = $scope.status.imgSrc;
            img.onload = function() {
                $timeout(function() {
                    $scope.status.orgWidth = img.width;
                    $scope.status.orgHeight = img.height;
                });
                $img.attr('src', $scope.status.imgSrc);
                options = {
                    // aspectRatio: 16 / 9,
                    viewMode: 1,
                    checkCrossOrigin: false,
                    zoomable: true,
                    dragMode: 'move',
                    movable: true,
                    // minCropBoxWidth: params.pictureSize.width,
                    // minCropBoxHeight: params.pictureSize.height,
                    aspectRatio: params.pictureSize.width / params.pictureSize.height,
                    autoCropArea: 0.1,

                    /* aspectRatio: aspectRatio,
                    autoCropArea: 0.1,
                    cropBoxResizable: false,*/
                    crop: function(e) {
                        // console.log(e);
                    }
                };
                $img.on({
                    'build.cropper': function(e) {
                        // console.log(e.type);
                    },
                    'built.cropper': function(e) {
                        containerWidth = $img.cropper('getContainerData').width;
                        containerHeight = $img.cropper('getContainerData').height;
                        imgWidth = $img.cropper('getImageData').width;
                        imgHeight = $img.cropper('getImageData').height;
                        imgRatio = imgWidth / img.width;
                        $img.cropper('setCropBoxData', {
                            left: imgWidth / 4,
                            top: imgHeight / 4,
                            width: imgWidth / 2,
                            height: imgHeight / 2
                        });

                        // $img.cropper('setData', { left: 0, top: 0, width: Math.round(img.width / 2), height: Math.round(img.height / 2) });

                        // console.log(e.type);
                    },
                    'cropstart.cropper': function(e) {
                        flag = true;
                        // console.log(e.type, e.action);
                    },
                    'cropmove.cropper': function(e) {
                        // console.log(e.type, e.action);
                    },
                    'cropend.cropper': function(e) {

                        /* var cropBoxData = $img.cropper("getCropBoxData");
                        var marginLeft = (containerWidth - imgWidth) / 2;
                        var marginTop = (containerHeight - imgHeight) / 2;
                        var left = cropBoxData.left - marginLeft;
                        var top = cropBoxData.top - marginTop;
                        var width = cropBoxData.width / imgRatio;
                        var height = cropBoxData.height / imgRatio;
                        $("#horizontal").val(Math.round(left));
                        $("#vertical").val(Math.round(top));
                        $("#realWidth").val(Math.round(width));
                        $("#realHeight").val(Math.round(height));*/
                        // console.log(e.type, e.action);
                    },
                    'crop.cropper': function(e) {
                        delete $scope.status.previewResult; // 删除上次预览结果
                        $scope.status.event = event = e;
                        previewImgDivStyle(e);
                        if (!flag) {return;}
                        $('#horizontal').val(Math.round(e.x));
                        $('#vertical').val(Math.round(e.y));
                        $('#realWidth').val(Math.round(e.width));
                        $('#realHeight').val(Math.round(e.height));
                    },
                    'zoom.cropper': function(e) {}
                }).cropper(options);
                $('#horizontal').bind('change', function() {
                    flag = false;
                    var myValue = parseFloat($(this).val()),
                        width;
                    myValue = myValue > 0 ? myValue : 0;
                    myValue = myValue > $scope.status.orgWidth ? $scope.status.orgWidth : myValue;
                    if ((myValue + event.width) > $scope.status.orgWidth) {
                        width = $scope.status.orgWidth - myValue;
                        $('#realWidth').val(Math.round(width));
                    }
                    $(this).val(myValue);
                    var margin = (containerWidth - imgWidth) / 2;
                    $img.cropper('setCropBoxData', { left: myValue * imgRatio + margin, width: width * imgRatio });
                });
                $('#vertical').bind('change', function() {
                    flag = false;
                    var myValue = parseFloat($(this).val()),
                        height;
                    myValue = myValue > 0 ? myValue : 0;
                    myValue = myValue > $scope.status.orgHeight ? $scope.status.orgHeight : myValue;
                    if ((myValue + event.height) > $scope.status.orgHeight) {
                        height = $scope.status.orgHeight - myValue;
                        $('#realHeight').val(Math.round(height));
                    }
                    $(this).val(myValue);
                    var margin = (containerHeight - imgHeight) / 2;
                    $img.cropper('setCropBoxData', { top: myValue * imgRatio + margin, height: height * imgRatio });
                });
                $('#realWidth').bind('change', function() {
                    flag = false;
                    var myValue = parseFloat($(this).val());
                    myValue = myValue > 0 ? myValue : 0;
                    myValue = myValue + event.x > $scope.status.orgWidth ? ($scope.status.orgWidth - event.x) : myValue;
                    myValue = Math.round(myValue);
                    $(this).val(myValue);
                    $img.cropper('setCropBoxData', { width: myValue * imgRatio });
                });
                $('#realHeight').bind('change', function() {
                    flag = false;
                    var myValue = parseFloat($(this).val());
                    myValue = myValue > 0 ? myValue : 0;
                    myValue = myValue + event.y > $scope.status.orgHeight ? ($scope.status.orgHeight - event.y) : myValue;
                    myValue = Math.round(myValue);
                    $(this).val(myValue);
                    $img.cropper('setCropBoxData', { height: myValue * imgRatio });
                });
            };
            deffer.resolve();
        });
        return deffer.promise;
    }

    /**
     * [initData description]初始化数据
     */
    function initData() {
        $scope.loadingPromise = initCropper();
    }

    /**
     * [cancel description]取消图片编辑 关闭窗口
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    /**
     * [cropper description]裁剪图片 关闭窗口
     */
    $scope.cropper = function() {
        // modalDialog.alertType("确定要裁剪该图片？", "", "info", true, function() {
        if ($scope.status.previewResult) {
            $modalInstance.close($scope.status.previewResult);
            return;
        }
        cropper().then(function(result) {
            $modalInstance.close(result);
        });
        // });
    };

    /**
     * [previewImgDiv description]预览框的样式设定
     */
    function previewImgDivStyle(event) {
        var width, height;
        var cropperAspectRatio = event.width / event.height;
        var divAspectRatio = 150 / 150;
        if (cropperAspectRatio > divAspectRatio) {
            width = '80px';
            height = 80 / cropperAspectRatio + 'px';
        } else {
            height = '80px';
            width = 80 * cropperAspectRatio + 'px';
        }
        $scope.status.imgOuterDiv = 'width:' + width + ';height:' + height;
        previewImgStyle(event, width, height);
    }

    /**
     * [previewImgDiv description]预览框的图片样式设定
     */
    function previewImgStyle(event, preDivWidth, preDivHeight) {
        preDivWidth = parseFloat(preDivWidth.replace(/px/, ''));
        preDivHeight = parseFloat(preDivHeight.replace(/px/, ''));
        var cropRadio, preImgWidth, preImgHeight, zoomRadio, preTop, preLeft;
        var imgAspectRatio = $scope.status.orgWidth / $scope.status.orgHeight;
        if (Math.abs(event.rotate) === 90 || Math.abs(event.rotate) === 270) {
            cropRadio = event.width / $scope.status.orgHeight;
            preImgWidth = (preDivWidth / cropRadio) * imgAspectRatio;
            preImgHeight = preImgWidth / imgAspectRatio;
            zoomRadio = preImgWidth / $scope.status.orgWidth;
            preTop = (-event.y * zoomRadio) - (preImgHeight - preImgWidth) / 2 + 'px';
            preLeft = (-event.x * zoomRadio) + (preImgHeight - preImgWidth) / 2 + 'px';
        } else {
            cropRadio = event.width / $scope.status.orgWidth;
            preImgWidth = (preDivWidth / cropRadio);
            zoomRadio = preImgWidth / $scope.status.orgWidth;
            preTop = (-event.y * zoomRadio) + 'px';
            preLeft = (-event.x * zoomRadio) + 'px';
        }
        $timeout(function() {
            $scope.status.imgStyle = 'width:' + preImgWidth + 'px;top:' + preTop + ';left:' + preLeft + ';transform:rotate(' + $scope.status.rotate + 'deg)';
        });
    }

    /**
     * [preview description]预览裁剪图片
     */
    $scope.preview = function() {
        if ($scope.status.previewResult) {
            editPictureService.newCropperPreview($scope.status.previewResult);
        } else {
            cropper().then(function(result) {
                $scope.status.previewResult = result;
                editPictureService.newCropperPreview($scope.status.previewResult);
            });
        }
    };

    /**
     * [cropper description]裁剪接口
     */
    function cropper() {
        var deffer = $q.defer();
        var params = {
            serviceid: 'mlf_image',
            methodname: 'cropimage',
            FILENAME: editPictureService.getFileName($scope.status.imgSrc), // zone
            X: Math.round(event.x),
            Y: Math.round(event.y),
            WIDTH: Math.round(event.width),
            HEIGHT: Math.round(event.height)
        };
        $scope.cutPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            var result = {
                imgName: data.FN,
                imgSrc: '/wcm/file/read_image.jsp?FileName=' + data.FN,
                success: '上传成功'
            };
            deffer.resolve(result);
        });
        return deffer.promise;
    }

    /**
     * [sizeRound description]四舍五入
     * @param  {[float]} floatNum [description] 小数
     * @return {[int]}  intNum [description] 整数
     */
    $scope.sizeRound = function(floatNum) {
        return Math.round(floatNum);
    };

    /**
     * [zoom description]按钮缩放
     * @param  {[string]} value [description] 缩放值
     */
    $scope.zoom = function(value) {
        $img.cropper('zoom', parseFloat(value));
    };

    /**
     * [turnPicture description]图片旋转
     * @param  {[string]} value [description] 角度
     */
    $scope.turnPicture = function(value) {
        $scope.cutPromise = editPictureService.rotateImage(value, $scope.status.imgSrc).then(function(imgName) {
            $scope.status.imgSrc = '/wcm/openapi/readimg?FileName=' + imgName;
            initCropper().then(function() {
                $img.cropper('replace', $scope.status.imgSrc, false);
            });
        });
    };

    /**
     * [reset description]重置裁剪
     */
    $scope.reset = function() {
        $scope.status.rotate = 0; // 重置时预览框的角度变为0
        $scope.status.imgSrc = params.imgSrc;
        initCropper().then(function() {
            $img.cropper('replace', $scope.status.imgSrc, false);
        });
    };
}]);
